export default {"src":"/_next/static/media/arrowUp.4fac2bf1.svg","height":10,"width":15};